module.exports = __webpack_public_path__ + "img/mrslotty.025a6951.svg";